module.exports = __webpack_public_path__ + "img/home_unselected.ab427b34.svg";